import { useModal } from "@/providers/modal-provider";
import React from "react";
import styled, { keyframes } from "styled-components";
import { H3 } from "../typography";
import { tablet, laptop, desktop } from "@/theme/common";

/**
 * Animations
 */
const slideUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

/**
 * Styled Components
 */

export const ModalWrapper = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: ${({ $isOpen }) => ($isOpen ? "100%" : "0")};
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 1000;
  transition: height 0.3s ease;

  ${tablet(`
    align-items: center;
  `)};
`;

export const ModalContent = styled.div<{ $isOpen: boolean }>`
  background: white;
  width: 100%;
  max-height: 90dvh;
  gap: 16px;
  padding: 24px 16px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  animation: ${slideUp} 0.3s ease;

  max-width: 500px;

  ${tablet(`
    width: 80%;
    max-height: 80dvh;
    border-radius: 16px;
    align-self: center;
    border-radius: 16px;
  `)};

  ${laptop(`
    width: 60%;
    max-height: 70dvh;
    align-self: center;
    border-radius: 16px;
  `)};

  ${desktop(`
    width: fit-content;
    max-height: 60dvh;
    align-self: center;
    border-radius: 16px;
  `)};
`;

export const ModalHeader = styled(H3)`
  padding: 16px;
  padding-top: 50px;
  word-wrap: break-word;
  text-align: center;
`;

export const ModalBody = styled.div`
  padding: 16px;
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const ModalFooter = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 30px;
  cursor: pointer;
  align-self: flex-end;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

/**
 * Modal Component
 */

export const Modal = () => {
  const { isOpen, content, closeModal } = useModal();

  if (!isOpen) return null;

  return (
    <ModalWrapper $isOpen={isOpen} onClick={closeModal}>
      <ModalContent $isOpen={isOpen} onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={closeModal}>&times;</CloseButton>
        {content}
      </ModalContent>
    </ModalWrapper>
  );
};
